import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchPosDecentralized,
  fetchDecentralizedFilterApi,
  fetchDecentralizedByIdApi,
  addChildPosApi,
  updateChildPosApi,
} from "../../../api/endpoint";

function* getPosDecentralizedSaga(action) {
  try {
    const _api = yield call(fetchPosDecentralized, action.payload);
    yield put(actions.setPosDecentralized(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* filterDecentralizedSaga(action) {
  try {
    const _api = yield call(fetchDecentralizedFilterApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setDecentralizedFilteredResults(_api.data.results));
      yield put(commonActions.setClearFilter(true));
    }
  } catch (error) {
    console.log(error);
  }
}

function* getPosDecentralizedByIdSaga(action) {
  try {
    const _api = yield call(fetchDecentralizedByIdApi, action.payload);
    yield put(actions.setPosDecentralizedById(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

function* addChildPosSaga(action) {
  try {
    const _api = yield call(addChildPosApi, action.payload);
    // yield put(actions.setPosDecentralizedById(..._api.data.results));
    // yield put(commonActions.setLoading(false));
    if (_api?.data?.success) {
      yield put(commonActions.setRedirect(true));
    }
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

function* updateChildPosSaga(action) {
  try {
    const _api = yield call(updateChildPosApi, action.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setLoading(false));
      yield put(commonActions.setRedirect(true));
    }
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

export function* watchPosDecentralizedSaga() {
  yield all([
    takeEvery(actionTypes.GET_POS_DECENTRALIZED, getPosDecentralizedSaga),
    takeEvery(
      actionTypes.GET_DECENTRALIZED_FILTERED_RESULTS,
      filterDecentralizedSaga
    ),

    takeEvery(
      actionTypes.GET_POS_DECENTRALIZED_BY_ID,
      getPosDecentralizedByIdSaga
    ),
    takeEvery(actionTypes.ADD_CHILD_POS, addChildPosSaga),
    takeEvery(actionTypes.UPDATE_CHILD_POS, updateChildPosSaga),
  ]);
}
